import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import './Login.css';
import { useUser } from '../context/UserContext';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { user, setUserAndToken } = useUser();

  useEffect(() => {
    if (user) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, navigate]);

  const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:8001";
  // console.log("BACKEND_BASE_URL:", BACKEND_BASE_URL);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      const response = await fetch(`${BACKEND_BASE_URL}/api/v1/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
        credentials: "include",
      });
      if (response.ok) {
        setError("");
        const data = await response.json();
        setUserAndToken(
          {
            id: data.user.id,
            name: data.user.name || 'Super Administrator',
            email: data.user.email,
            role: data.user.role,
            status: data.user.status
          },
          data.access_token
        );
        navigate('/dashboard');
      } else {
        const data = await response.json();
        setError(data.detail || 'Invalid email or password. Please try again.');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    }
  };

  if (user) return null;

  return (
    <div className="login-bg">
      <div className="login-container">
        <div className="login-logo">
          <img src="/logo192.png" alt="ARiA Logo" style={{ width: 60, marginBottom: 8 }} />
          <div className="login-title-logo"></div>
        </div>
        <h2 className="login-title">ARiA Admin Portal</h2>
        <div className="login-subtitle">Sign in to your account</div>
        <form className="login-form" onSubmit={handleSubmit}>
          <label className="login-label">Email Address</label>
          <input
            className="login-input"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="admin@meet-aria.com"
            required
          />
          <label className="login-label">Password</label>
          <div className="login-password-wrapper">
            <input
              className="login-input"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Password"
              required
            />
            <button
              type="button"
              className="login-password-toggle"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
          <div className="login-options" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <label style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type="checkbox"
                checked={remember}
                onChange={e => setRemember(e.target.checked)}
              />
              <span style={{ marginLeft: 8 }}>Remember me</span>
            </label>
            <a href="#" className="login-forgot" style={{ marginLeft: 'auto' }}>Forgot password?</a>
          </div>
          {error && <div className="login-error">{error}</div>}
          <button className="login-button" type="submit">Sign In</button>
        </form>
      </div>
    </div>
  );
};

export default Login; 